export default "__VITE_ASSET__Dlotp25L__"